$(() => {
  const gridItems = $('.recipe-item.visible');

  gridItems.click((event) => {
    const currentRecipe = $(event.currentTarget);
    const currentRecipeImg = currentRecipe.attr('style').replace('-300x300', '');
    const previousRecipe = $('.recipe-item.open');
    const itemPosition = gridItems.index(event.currentTarget);
    const itemId = currentRecipe.data('postid');

    slideDetailUp();
    previousRecipe
      .find('.recipe-item__title')
      .animate({
        height: '54px',
      }, 0, () => {
        previousRecipe.removeClass('open');
      });
    currentRecipe
      .addClass('open')
      .find('.recipe-item__title')
      .animate({
        height: '100%',
      }, 0, () => {
        currentRecipe.addClass('loading');
      });

    getDetails(itemId, currentRecipeImg, (detailsTemplate) => {
      currentRecipe.removeClass('loading');
      removePreviousDetails()
        .done(insertDetails(itemPosition, detailsTemplate));
    });
  });

  function getDetails(id, currentRecipeImg, cb) {
    let recipeContent;
    let detailsTemplate;
    const url = `/wp-json/wp/v2/recipe/${id}`;

    $.getJSON({
      url,
    }).done((response) => {
      recipeContent = _.get(response.content, 'rendered');
      detailsTemplate = createDetailsTemplate(recipeContent, currentRecipeImg);
      cb(detailsTemplate);
    }).fail((error) => {
      recipeContent = '<h1>There was a problem retrieving this recipe\'s details</h1>';
      detailsTemplate = createDetailsTemplate(recipeContent, currentRecipeImg);
      cb(detailsTemplate);
    });
  }

  function createDetailsTemplate(recipeContent, currentRecipeImg) {
    const detailsTemplate = `
      <div class="recipe-item__detail grid-item__detail">
        <div class="recipe-item__image" style='${currentRecipeImg}'></div>
        ${recipeContent}
      </div>`;
    return detailsTemplate;
  }

  function removePreviousDetails(detailsTemplate) {
    const d = $.Deferred();
    const gridDetailContainer = $('.grid-detail__container');
    if (gridDetailContainer) {
      gridDetailContainer.remove();
    }
    return d.resolve(detailsTemplate);
  }

  function insertDetails(itemPosition, itemDetailsHtml) {
    const screenSize = $(window).width();
    let grid = 2; // small
    if (screenSize > 1199) { // xlarge
      grid = 4;
    } else if (screenSize > 991) { // large
      grid = 3;
    }
    let detailPosition = (Math.ceil((itemPosition + 1) / grid) * grid);
    if (detailPosition > gridItems.length) {
      detailPosition = gridItems.length;
    }
    const itemDetails = `<div class="grid-detail__container">
      <button type="button" class="detail-container__close" data-dismiss="detail" aria-label="Close"><span aria-hidden="true"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve">
      <g>
        <polygon style="fill:#010002;" points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254
          0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254   "/>
      </g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
      </svg></span></button>
      <div class="detail-container__flex">${itemDetailsHtml}</div>
    </div>`;
    const d = $.Deferred;
    const detailDomPosition = $(gridItems[detailPosition - 1]);
    window.setTimeout(() => {
      detailDomPosition.after(itemDetails);
      slideDetailDown();
      refreshCloseEventListener();
      scrollToDetail(detailDomPosition);
    }, 350);
  }

  function slideDetailDown() {
    $('.grid-detail__container').slideDown(350);
  }

  function slideDetailUp() {
    $('.grid-detail__container').slideUp(350);
  }

  function refreshCloseEventListener() {
    $('.detail-container__close').off();
    $('.detail-container__close').on('click', () => {
      $('.grid-detail__container').slideUp(400, function() { $('.grid-detail__container').remove() });
      $('.recipe-item.open')
        .find('.recipe-item__title')
        .animate({
          height: '54px',
        }, 0, () => {
          $('.recipe-item.open').removeClass('open');
        });
    });
  }

  function scrollToDetail(detailDomPosition) {
    const gridItemHeight = detailDomPosition.outerHeight() - 100;
    const detailPosition = detailDomPosition.offset();
    const scrollPosition = detailPosition.top + gridItemHeight;
    $('html, body').animate({
      scrollTop: scrollPosition,
    }, 350);
  }
});
